/* eslint-disable @typescript-eslint/no-var-requires */
import { AwsCognitoConfig } from './types/types';

let awsConfig: AwsCognitoConfig;

if (process.env.REACT_APP_ENV === 'production') {
  awsConfig = require('./aws-exports.prod').awsConfig;
} else {
  awsConfig = require('./aws-exports.dev').awsConfig;
}

export { awsConfig };
